module.exports = __webpack_public_path__ + "static/media/error.17648f2f.png";